import { defineField, defineType } from "sanity";

export const contactPage = defineType({
  name: "contactPage",
  title: "Contact Page",
  type: "document",
  groups: [
    { name: "content", title: "Content", default: true },
    { name: "form", title: "Form" },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    defineField({
      name: "contactHeader",
      title: "Contact header",
      type: "string",
      description: "Main heading for the Contact page.",
      group: "content"
    }),
    defineField({
      name: "contactBody",
      title: "Contact body",
      type: "text",
      rows: 4,
      description: "Supporting copy for the Contact page.",
      group: "content"
    }),
    defineField({
      name: "formFirstNameLabel",
      title: "First name label",
      type: "string",
      description: "Label for the first name field (e.g. 'First name').",
      group: "form"
    }),
    defineField({
      name: "formLastNameLabel",
      title: "Last name label",
      type: "string",
      description: "Label for the last name field (e.g. 'Last name').",
      group: "form"
    }),
    defineField({
      name: "formDateLabel",
      title: "Date field label",
      type: "string",
      description: "Label for the date field (e.g. 'Relevant date').",
      group: "form"
    }),
    defineField({
      name: "formEmailLabel",
      title: "Email label",
      type: "string",
      description: "Label for the email field (e.g. 'Email').",
      group: "form"
    }),
    defineField({
      name: "formMessageLabel",
      title: "Message label",
      type: "string",
      description: "Label for the message field (e.g. 'Message').",
      group: "form"
    }),
    defineField({
      name: "formButtonText",
      title: "Submit button text",
      type: "string",
      description: "Text on the form submit button (e.g. 'Send').",
      group: "form"
    }),
    defineField({
      name: "formFooterText",
      title: "Form footer text",
      type: "string",
      description: "Text shown below the form (e.g. 'Do not hesitate to contact us with any inquiries').",
      group: "form"
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines (e.g. 'Contact | Vault 88').",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({
      title: "Contact Page"
    })
  }
});
